import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  danger?: boolean;
}

export function SectionCard({ title, description, children, danger }: SectionCardProps) {
  return (
    <section
      className={`rounded-2xl border p-6 ${
        danger ? 'border-red-500/40 bg-red-950/10' : 'border-slate-700/40 bg-slate-900/30'
      }`}
    >
      <h2 className={`text-sm font-semibold uppercase tracking-wide ${danger ? 'text-red-300' : 'text-amber-400'}`}>
        {title}
      </h2>
      {description ? <p className="mt-1 text-sm text-slate-400">{description}</p> : null}
      <div className="mt-4 space-y-4">{children}</div>
    </section>
  );
}
